export const ENERGY_UNIT = "MU";
export const COST_UNIT = "Rs/KWh";
export const COST_MU = "Rs/MWh";
export const COST = "₹ Cr";
export const VOLUME_UNIT = "MWh";
export const MEGA_POWER_UNIT = "MW";
export const GAS_DAY_UNIT = "MMSCMD";
